module.exports = __webpack_public_path__ + "static/img_9782_dpp_optimized-371eb214e01ee5cd76f2efe74020adfe.jpg";